/* DSL Cart-drawer — slide-from-right, focus-trap, ESC sluit */
(function(){
  var drawer, lastFocus, FOCUSABLE = "a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex=\"-1\"])";
  function ensure(){
    drawer = document.getElementById("dsl-cart-drawer");
    if (!drawer) {
      drawer = document.createElement("aside");
      drawer.id = "dsl-cart-drawer";
      drawer.className = "dsl-cart-drawer";
      drawer.setAttribute("role", "dialog");
      drawer.setAttribute("aria-modal", "true");
      drawer.setAttribute("aria-labelledby", "dsl-cd-title");
      drawer.hidden = true;
      drawer.innerHTML = "<button class=\"dsl-cart-drawer__overlay\" aria-label=\"Sluit\"></button>" +
        "<div class=\"dsl-cart-drawer__panel\">" +
        "<header class=\"dsl-cart-drawer__head\"><h2 id=\"dsl-cd-title\">Winkelwagen</h2>" +
        "<button class=\"dsl-cart-drawer__close\" aria-label=\"Sluit winkelwagen\">&times;</button></header>" +
        "<div class=\"dsl-cart-drawer__body\" data-cd-body>Laden...</div></div>";
      document.body.appendChild(drawer);
    }
    drawer.querySelectorAll(".dsl-cart-drawer__overlay, .dsl-cart-drawer__close").forEach(function(b){
      b.addEventListener("click", close);
    });
  }
  function open(){
    ensure();
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = "hidden";
    fetch("/cart.js", {headers:{Accept:"application/json"}}).then(function(r){ return r.json(); }).then(function(cart){
      var body = drawer.querySelector("[data-cd-body]");
      if (cart.item_count === 0){
        body.innerHTML = "<p>Je winkelwagen is leeg.</p><a class=\"button\" href=\"/collections/all\">Verder winkelen</a>";
        return;
      }
      var html = "<ul>" + cart.items.map(function(i){
        return "<li><img src=\"" + i.image + "\" width=\"60\" height=\"60\" alt=\"\" loading=\"lazy\"><div><strong>" + i.product_title + "</strong><br>" + i.quantity + " × €" + (i.price/100).toFixed(2) + "</div></li>";
      }).join("") + "</ul><p class=\"dsl-cart-drawer__total\">Totaal: €" + (cart.total_price/100).toFixed(2) + "</p><a class=\"button\" href=\"/cart\">Naar winkelwagen</a>";
      body.innerHTML = html;
    });
    setTimeout(function(){
      var first = drawer.querySelector(FOCUSABLE);
      if (first) first.focus();
    }, 50);
    if (window.DSL_AB) window.DSL_AB.track("cart_drawer_open", {});
  }
  function close(){
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = "";
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener("keydown", function(e){
    if (e.key === "Escape" && drawer && !drawer.hidden) close();
  });
  document.addEventListener("click", function(e){
    var t = e.target.closest("[data-cart-drawer-trigger], a[href=\"/cart\"]");
    if (t) {
      // Allow plain link if user holds modifier or middle-click
      if (e.metaKey || e.ctrlKey || e.button === 1) return;
      e.preventDefault();
      open();
    }
  });
  window.DSL_CART_DRAWER = {open: open, close: close};
})();